export default __webpack_public_path__ + "static/media/icon-patti-help-faq.a570309a.png";